module.exports = __webpack_public_path__ + "static/media/em-46.7a11ce14.png";